import { isUndef } from "@package/shared/util/data";
import { IStoreAdapter } from "@package/shared/util/storage";

export class LocalStorageAdapter implements IStoreAdapter {
  get<R = unknown>(key: string): (R extends undefined ? never : R) | null {
    let res = null;
    try {
      res = JSON.parse(localStorage.getItem(key) as string);
    } catch {
      this.del(key);
    }
    return res;
  }

  set(key: string, val: unknown): void {
    if (isUndef(val)) this.del(key);
    else localStorage.setItem(key, JSON.stringify(val));
  }

  del(key: string): void {
    localStorage.removeItem(key);
  }

  get size(): number {
    return localStorage.length;
  }

  has(key: string): boolean {
    return Object.hasOwn(localStorage, key);
  }

  keys(): Array<string> {
    return Object.keys(localStorage);
  }
}
